// @ts-check

import { PAGES } from "@consts";

/**
 * The two APIs have different structures, and they both return arrays where
 * we want an object. This method supplies a formatter that standardises things.
 * @param {WF_Common.RouteObject} route
 * @returns {WF_RequestMediator.FormatterSignature} The formatter callback
 */
export const getResultsFormatterForRoute = (route) => {
	switch (route.name) {
		case PAGES.WORDLE_RESULTS:
		case PAGES.QUORDLE_RESULTS:
		case PAGES.WORDS_STARTING_RESULTS:
		case PAGES.WORDS_ENDING_RESULTS:
		case PAGES.WORDS_HAVING_RESULTS:
		case PAGES.WORDS_BY_LENGTH_RESULTS:
		case PAGES.WORDS_COMBINATION_LETTERS_RESULTS:
		case PAGES.WORDS_COMBINATION_LENGTH_AND_LETTERS_RESULTS:
		case PAGES.WORDS_ENDING_ING:
		case PAGES.WORDS_WITH_Q_NO_U:
		case PAGES.WORDS_VOWELS:
		case PAGES.WORDS_CONSONANTS:
			/**
			 * @param {WF_RequestMediator.Responses.UnformattedWordlistGroup[]} groupsArray
			 */
			return (groupsArray = []) => {
				/** @type {WF_RequestMediator.Responses.FormattedResults} */
				const formattedResults = groupsArray.reduce((obj, group) => {
					/** @type {WF_RequestMediator.Responses.FormattedResultsGroup} */
					const formattedGroup = {
						_meta: group._meta,
						word_length: group.word_length,
						_items: group._items.map((w, i) => ({
							word: w,
							score: group._scores[i],
							mod: group._mod[i],
							has_definition: group._has_definition[i] === 1,
						})),
					};

					obj[group.word_length] = formattedGroup;
					return obj;
				}, {});
				return formattedResults;
			};
		default:
			/**
			 * @param {WF_RequestMediator.Responses.UnformattedUnscramblerGroup[]} groupsArray
			 */
			return (groupsArray = []) => {
				/** @type {WF_RequestMediator.Responses.FormattedResults} */
				const formattedResults = groupsArray.reduce((obj, group) => {
					/** @type {WF_RequestMediator.Responses.FormattedResultsGroup} */
					const formattedGroup = {
						...group,
						_items: group._items.map((item, i) => ({
							word: item.word,
							score: item.scores?.[0],
							mod: item.mod,
							has_definition:
								item.scores?.[item.scores.length - 1] === 1,
						})),
					};

					obj[group.word_length] = formattedGroup;
					return obj;
				}, {});

				return formattedResults;
			};
	}
};
